// app/javascript/landing/sections/ClientsStrip.tsx
import React from "react";
import { Section } from "../components/Section";
import { motion, Transition, Variants } from "framer-motion";

const transition: Transition = { duration: 1, ease: [0.25, 0.1, 0.25, 1] };
const variants: Variants = {
  hidden: { filter: "blur(10px)", transform: "translateY(20%)", opacity: 0 },
  visible: { filter: "blur(0)", transform: "translateY(0)", opacity: 1 },
};

const clients = [
  { name: "Aguas Pacífico", src: "/landing/clients/aguas.png" },
  { name: "Cenco Malls", src: "/landing/clients/cenco.png" },
  { name: "Cintac", src: "/landing/clients/cintac.png" },
  { name: "Promet", src: "/landing/clients/promet.png" },
  { name: "Swisscontact", src: "/landing/clients/swiss.png" },
];

export function ClientsStrip() {
  return (
    <motion.div
      className="x-bg-red-400 flex flex-col justify-center space-y-28"
      initial="hidden"
      whileInView="visible"
      transition={{ staggerChildren: 0.1 }}
    >
      {/* Encabezado */}
      <div className="max-w-6xl mx-auto text-center px-4">
        <div className="text-center space-y-1">
          <motion.h2
            className="text-4xl md:text-5xl font-bold text-purple-3"
            transition={transition}
            variants={variants}
          >
            Clientes
          </motion.h2>
          <motion.p
            className="text-xl md:text-2xl text-purple-3"
            transition={transition}
            variants={variants}
          >
            que han confiado en nosotros
          </motion.p>
        </div>
      </div>

      {/* Slider infinito (Alpine intacto) */}
      <div className="w-full inline-flex flex-nowrap overflow-hidden x-[mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-128px),transparent_100%)]">
        <ul className="flex items-center justify-center md:justify-start [&_li]:mx-12 [&_img]:max-w-none animate-infinite-scroll">
          {clients.map((client) => (
            <li key={client.name}>
              <motion.img
                transition={transition}
                variants={variants}
                src={client.src}
                alt={client.name}
                className="h-14 md:h-20 object-contain opacity-90"
              />
            </li>
          ))}
        </ul>
        <ul
          aria-hidden="true"
          className="flex items-center justify-center md:justify-start [&_li]:mx-12 [&_img]:max-w-none animate-infinite-scroll"
        >
          {clients.map((client) => (
            <li key={client.name}>
              <img
                src={client.src}
                alt={client.name}
                className="h-14 md:h-20 object-contain opacity-90"
              />
            </li>
          ))}
        </ul>
      </div>
    </motion.div>
  );
}
